import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/library-archive-update/library-archive-update.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};